/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import { Modal } from 'antd';
import { createGlobalStyle } from 'styled-components';
import Login from './login';
import Register from './register';

const GlobalModal = createGlobalStyle`
  
  background-color: red;
  .login-modal {
    .ant-modal-body {
      padding: 0;
      .anticon-info-circle {
        display: none;
      }
    .ant-modal-confirm-content {
      margin-top: 0;
    }
    .ant-modal-confirm-btns {
      display: none;
    }
  }
}
`;

const showModal = (type: 'login' | 'register') => {
  const { location } = window;

  const modal = Modal.info(
    (() => {
      const props = {
        onClose: () => {
          modal.destroy();
        },
        afterLogin: () => {
          modal.destroy();
          location.reload();
        },
        afterRegister: () => {
          modal.destroy();
          location.reload();
        },
        changeView: (viewName: any) => {
          modal.update({
            content: (
              <div>
                <GlobalModal />
                {viewName === 'login' ? <Login {...props} /> : <Register {...props} />}
              </div>
            ),
          });
        },
      };
      return {
        className: 'login-modal',
        width: 480,
        content: (
          <div>
            <GlobalModal />
            {type === 'login' ? <Login {...props} /> : <Register {...props} />}
          </div>
        ),
      };
    })()
  );
};

export const showLoginModal = () => {
  showModal('login');
};

export const showRegisterModal = () => {
  showModal('register');
};
